import PropTypes from "prop-types";
import React from "react";
import SearchableSelect from "../utils/searchableSelect";
import { URLs } from "../utils/apis";
import { Box, Checkbox, Flex, Text, useMantineTheme } from "@mantine/core";
import CustomTooltip from "./mantineCustomComponents/CustomTooltip";
import { useStylesTooltip } from "../utils/mantine/useStylesTooltip";
import { useStylesCollectionSelect } from "../utils/mantine/stampTabContent/useStylesCollectionSelect";
import CustomAnchor from "./mantineCustomComponents/CustomAnchor";

const CollectionSelect = ({
  activateSelectCollection,
  onActivateSelectCollection,
  selectCollections,
  onSelectedOptionCollection,
  selectedOptionCollection,
  helpIsActive,
  disableCheckbox = false,
  isPortfolioTab = false,
}) => {
  // Mantine theme instance to apply custom styles and theming throughout the component
  const theme = useMantineTheme();

  // css classes
  const { classes: tooltipClasses } = useStylesTooltip();
  const { classes: collectionSelectClasses } = useStylesCollectionSelect();

  const handleCheckboxChange = (event) => {
    onActivateSelectCollection(event.currentTarget.checked);
  };

  // selecting Collection Name for Stamp page
  return (
    <Box
      justify={theme.flex.justify.center}
      wrap="wrap"
      className={collectionSelectClasses.collectionSelect}
    >
      <Box>
        <Flex
          align={theme.flex.align.center}
          gap={theme.flex.gap.xs}
          mb={theme.margin.xsV2Em}
        >
          {isPortfolioTab ? (
            <Text className={collectionSelectClasses.collectionSelectLabel}>
              Select a Collection
            </Text>
          ) : (
            <Checkbox
              label="Stamp Belongs to Collection"
              id="stamp-belongs"
              className={`${collectionSelectClasses.collectionSelectCheckbox} stamp-collection-activate`}
              checked={activateSelectCollection}
              onChange={(event) => handleCheckboxChange(event)}
              disabled={disableCheckbox}
            />
          )}

          {helpIsActive && (
            <CustomTooltip
              classNames="tooltip-Bottom"
              content={
                <>
                  {isPortfolioTab ? (
                    <Text
                      classNames={{
                        root: tooltipClasses.tooltipText,
                      }}
                    >
                      A Collection groups related stamps into a strategy or a
                      signal. Select the strategy to which this portfolio
                      belongs.
                    </Text>
                  ) : (
                    <>
                      <Text
                        classNames={{
                          root: tooltipClasses.tooltipText,
                        }}
                      >
                        You can assign your vBase Stamps to Collections (think
                        of Collections like topics, for example: strategy1,
                        strategy2) etc.
                      </Text>
                      <Text
                        classNames={{
                          root: tooltipClasses.tooltipText,
                        }}
                      >
                        Someone verifying your stamps will be able to see how
                        many Collections you&apos;ve created and how many stamps
                        belong to each Collection.
                      </Text>
                    </>
                  )}
                </>
              }
            ></CustomTooltip>
          )}
        </Flex>
      </Box>
      <Flex justify={theme.flex.justify.between}>
        <SearchableSelect
          selectCollections={selectCollections}
          disabled={!activateSelectCollection}
          onSelectedOptionCollection={onSelectedOptionCollection}
          selectedOptionCollection={selectedOptionCollection}
        />

        <CustomAnchor
          text="+"
          componentClasses={collectionSelectClasses.collectionSelectPlus}
          href={URLs.USER_COLLECTIONS_URL}
        />
      </Flex>
    </Box>
  );
};

CollectionSelect.propTypes = {
  activateSelectCollection: PropTypes.bool.isRequired,
  handleCheckboxChange: PropTypes.func,
  selectCollections: PropTypes.array.isRequired,
  onSelectedOptionCollection: PropTypes.func.isRequired,
  helpIsActive: PropTypes.bool.isRequired,
  onActivateSelectCollection: PropTypes.func.isRequired,
  selectedOptionCollection: PropTypes.string,
  disableCheckbox: PropTypes.bool,
  isPortfolioTab: PropTypes.bool,
};
export default CollectionSelect;
